export default __webpack_public_path__ + "b522a14e7da5f71a12f3eef2b1c9acfb.png";